import { useContext } from 'react'
import { AlertContext } from './AlertContext'

export const useAlertState = () => {
  return useContext(AlertContext)
}
